import { MenuFilter } from "@/common/MenuFilter";
import { Status } from "@/common/NotesTable/Components/Status";
import { NOTE_STATUS } from "@/services/api";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import type { NotesTableRowData } from "../types/notes-table-types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";
export type NotesTableNoteStatusColumnProps = NotesTableColumnsProps<{
  menuFilters?: MenuFilter[];
  onChangeMenuFilters?: (selected: string[]) => void;
}>;

export type NotesTableNoteStatusColumnGetter =
  NotesTableColumnGetter<NotesTableNoteStatusColumnProps>;

export const getNotesTableNoteStatusColumn: NotesTableNoteStatusColumnGetter = ({
  title = "Status",
  ellipsis = true,
  dataIndex = ["status"],
  minWidth = 95,
  width = 95,
  key = NOTES_TABLE_COLUMNS_KEYS.status,
  showSorterTooltip = false,
  sorter = (a: NotesTableRowData, b: NotesTableRowData) => {
    if (a.status === b.status) return 0;
    if (a.status === NOTE_STATUS.DONE) return 1;
    if (b.status === NOTE_STATUS.DONE) return -1;
    return 0;
  },
  menuFilters = [],
  onChangeMenuFilters = () => "",
  filterDropdown = () => <MenuFilter onChange={onChangeMenuFilters} filters={menuFilters} />,
  onFilter = (value, record) => record?.status?.includes(value as string) ?? false,
  render = (_, record) => (
    <>
      <Status isShowTag={true} status={record.status} />
    </>
  ),
  ...props
}) => {
  return {
    title: title,
    ellipsis: ellipsis,
    dataIndex: dataIndex,
    minWidth: minWidth,
    width: width,
    key: key,
    sorter: sorter,
    filterDropdown: filterDropdown,
    onFilter: onFilter,
    render: render,
    showSorterTooltip,
    ...props,
  };
};
